for (const el of document.querySelectorAll('.gz-report-link')) {
	el.addEventListener('click', event => {
		event.preventDefault();
		if(el.dataset.reportLink) {
			let url = el.dataset.reportLink;
			window.open(url,'_blank');
		}		
	});
}

const filtersRow = document.querySelector('.gz-row-filters-cat');
if (filtersRow) {
	const isSearchPage = filtersRow.classList.contains('gz-row-filters-search');
	
	if(!isSearchPage) {
		const filterButtons = filtersRow.querySelectorAll('.gz-button');

		for(const button of filterButtons){
			let btnLabel = button.querySelector('.gz-hide-mobile').textContent.trim();
			button.addEventListener('click', () => {
				eventAnalytics('Click su ' + btnLabel, 'Interazione');
			});
		}
	}
}

let portateLinks = document.querySelectorAll('.gz-modal-categorie a'); 
if(portateLinks && portateLinks.length > 0) {
	portateLinks.forEach(el => {
		el.addEventListener('click', event => {
			let linkLabel = event.target.textContent.trim();
			eventAnalytics('Click dentro modale portate', 'Interazione', linkLabel);
		});
	});
}

(filters = () => {
	var modalName = 'filtri-listing';
	var target = document.querySelector('.gz-modal-container[data-modalname='+modalName+']');
	if(!target){
		return;
	}

	var original_form_action = target.querySelector(':scope form').getAttribute('action');
	
	var main_filter;
	var original_main_filter = document.getElementById('main_filter').value;
	main_filter = original_main_filter;
	
	var search_query;
	var original_search_query = document.getElementById('search_query').value;
	search_query = original_search_query;
	
	var main_filter_tags = document.getElementById('main_filter_tags').value ? JSON.parse(document.getElementById('main_filter_tags').value) : {};
	var cleaned_query = document.getElementById('cleaned_query').value ? JSON.parse(document.getElementById('cleaned_query').value) : {};
	
	var filter_statuses = {};
	var original_filter_statuses = {};
	
	target.querySelectorAll(':scope input[type=radio]').forEach(el => {
		if(el.getAttribute("id")){
			original_filter_statuses[el.getAttribute("id")] = filter_statuses[el.getAttribute("id")] = el.checked;
		}
	});
	
	// on change -> submit & update filters
	var filtersSubmit = (first_submit) => {
		var el_id;
		var form = target.querySelector(':scope form');
		var form_action = form.getAttribute('action');

		if (search_query) {
			//modifica della query di ricerca in base ai filtri benessere selezionati
			var q = search_query;
			for (el_id in main_filter_tags) {
				if (document.getElementById(el_id)) {
					var el = document.getElementById(el_id);
					if (!el.checked && cleaned_query[el.dataset.label]) {  //non checked & in query > rimuovo
						q = cleaned_query[el.dataset.label];
					}
				}
			}
			if (q != search_query) {
				form_action = '/ricerca-ricette/' + q.replace(/ +/g, '+') + '/';
				search_query = q;
			}
		} else {
			//verifico se il filtro in url è ancora selezionato, altrimenti lo elimino
			for (el_id in main_filter_tags) {
				if (main_filter_tags[el_id] == main_filter && document.getElementById(el_id)) {
					if (!document.getElementById(el_id).checked) {
						form_action = form_action.replace(main_filter, '');
						main_filter = '';
					}
					break;
				}
			}
			//se non c'è un filtro principale, controllo se è selezionato un altro candidato a filtro in url
			if (main_filter == '') {
				for (el_id in main_filter_tags) {
					if (document.getElementById(el_id)){
						if (document.getElementById(el_id).checked) {
							main_filter = main_filter_tags[el_id];
							form_action = form_action + main_filter_tags[el_id];
							break;
						}
					}
				}
			}
		}
		form.setAttribute('action', form_action);
		
		// recupero filtri attivabili con la selezione corrente e aggiorno modale
		var form_data = serialize(form);
		form_data += (form_data ? '&' : '') + 'q=' + encodeURIComponent(form_action);

		fetch( '/ajax/filters.php?' + form_data)
			.then(response => {
				return response.json()
			})
			.then(data => {
				if (data.filters) {
					cleaned_query = data.cleaned_query ? data.cleaned_query : {};
					for (var group in data.filters) if (document.getElementById('f-'+group)) {
						var sum = 0;
						for (var id in data.filters[group]) if (document.getElementById(group+'-'+id)) {
							sum += data.filters[group][id];
							document.getElementById(group+'-'+id).parentNode.style.display = (data.filters[group][id] > 0 ? '' : 'none');
						}
						if (group != 'portate') document.getElementById('f-'+group).style.display = (sum > 0 ? '' : 'none');
					}
				}
				if (data.results) {
					document.getElementById('filtri-submit').textContent = dictionary.filterWatchResults + ' '+ data.results + ' ' + (data.results == 1 ? dictionary.filterResult : dictionary.filterResults);
					if (first_submit !== true) document.getElementById('filtri-submit').disabled = false;
				} else {
					document.getElementById('filtri-submit').textContent = dictionary.filterZeroResults;
					document.getElementById('filtri-submit').disabled = true;
				}
				if (first_submit !== true) {
					document.getElementById('filtri-reset').style.display = 'block';
				}
			}
        );
	};
	
	filtersReset = () => {
		target.querySelector(':scope form').reset();
		var range = target.querySelector(':scope input.multirange.original');
		if (range) {
			range = range.get(0);
			range.value = range.defaultValue;
		}
		main_filter = original_main_filter;
		search_query = original_search_query;
		target.querySelector(':scope form').setAttribute('action', original_form_action);
		for (var id in original_filter_statuses) if (document.getElementById(id)) {
			document.getElementById(id).checked = filter_statuses[id] = original_filter_statuses[id];
		}
		document.getElementById('filtri-reset').style.display = "none";
		document.getElementById('filtri-submit').disabled = true;
		filtersSubmit(true);
	};
	
	// on filter reset -> reset filters, submit request
	document.getElementById('filtri-reset').addEventListener('click', function(event) {
		event.preventDefault();
		filtersReset();
		eventAnalytics('Click dentro modale filtri', 'Interazione', 'Annulla');
	});
	
	// on filters modal open -> reset filters, submit request
	// (openModal viene emesso per qualunque modale: login, newsletter... non serve resettare i filtri)
	document.addEventListener('openModal', function(event) {
		if (event.detail && event.detail.modal_name !== modalName) {
			return;
		}
		filtersReset();
	});

	// on radio click -> if checked uncheck
	target.querySelectorAll(':scope input[type=radio]').forEach(radio => {
		radio.addEventListener('click', function() {
			if (this.getAttribute(id)) {
				if (this.checked && filter_statuses[this.id]) {
					this.checked = false;
					filter_statuses[this.id] = false;
					let rangeChangedEvent = new CustomEvent('change');
					document.dispatchEvent(rangeChangedEvent);
				} else {
					var group = this.id.replace(this.value, '');
					for (var id in filter_statuses) if (id.indexOf(group) === 0) {
						filter_statuses[id] = false;
					}
					filter_statuses[this.id] = true;
				}
			}
		});
	});

	// on change -> submit
	target.querySelectorAll('input[type=radio],input[type=checkbox]').forEach(el => {
		el.addEventListener('change', filtersSubmit);
	});
	// document.addEventListener('rangeChanged', filtersSubmit);
	
	// button on click -> search
	target.querySelector('form').addEventListener('submit', function() {
		for (var el_id in main_filter_tags) if (main_filter_tags[el_id] == main_filter) {
			document.getElementById(el_id).disabled = true;
			break;
		}

		// Evento analytics con filtri selezionati
		var selectedFiltersArry = [];
		target.querySelectorAll('input[type=checkbox]:checked').forEach(function(input) {
			var name = input.name;
			var match = name.match(/^([^[]+)\[([^\]]+)\]$/);
			if (match) {
				selectedFiltersArry.push(match[1] + ': ' + match[2]);
			} else {
				selectedFiltersArry.push(name + ':' + input.value);
			}
		});
		target.querySelectorAll('input[type=radio]:checked').forEach(function(input) {
			selectedFiltersArry.push(input.name + ': ' + input.value);
		});
		if(selectedFiltersArry.length > 0) {
			let selectedFilters = selectedFiltersArry.join(', ');
			eventAnalytics('Click dentro modale filtri', 'Interazione', selectedFilters);
		}

		/*
		var range = target.querySelector('input.multirange.original');
		if(range){
			range = (range.length > 0) ? range.get(0) : false;
			if (range && range.valueLow == range.min) {
				target.querySelector('input[name=calories_min]').removeAttribute('name');
			}
			if (range && range.valueHigh == range.max) {
				target.querySelector('input[name=calories_max]').removeAttribute('name');
			}
		}
		*/
		return true;
	});	

	target.querySelector('.gz-modal-close').addEventListener('click', () => {
		eventAnalytics('Click dentro modale filtri', 'Interazione', 'Chiudi');
	});
})();

// Evento analytics su bottone benessere (filtri)
const filterBenessereBtn = document.querySelector('.gz-button-benessere');
if(filterBenessereBtn){
	let filterBenessereAction = 'aggiunta filtro';
	if(filterBenessereBtn.classList.contains('gz-button-benessere-active')) {
		filterBenessereAction = 'rimozione filtro';
	}
	filterBenessereBtn.addEventListener('click', () => {
		eventAnalytics('Filtro benessere', 'Interazione', 'Click su bottone benessere - ' + filterBenessereAction);
	});
}

rangeSlider = () => {
	var supportsMultiple = self.HTMLInputElement && "valueLow" in HTMLInputElement.prototype;
	var descriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, "value");
	var multirange = function (input) {
		if (supportsMultiple || input.classList.contains("multirange")) {
			return;
		}

		var value = input.getAttribute("value");
		var values = value === null ? [] : value.split(",");
		var min = +(input.min || 0);
		var max = +(input.max || 100);
		var ghost = input.cloneNode();

		input.classList.add("multirange", "original");
		ghost.classList.add("multirange", "ghost");

		input.value = values[0] || min + (max - min) / 2;
		ghost.value = values[1] || min + (max - min) / 2;

		input.parentNode.insertBefore(ghost, input.nextSibling);

		Object.defineProperty(input, "originalValue", descriptor.get ? descriptor : {
			get: function () {
				return this.value;
			},
			set: function (v) {
				this.value = v;
			}
		});

		Object.defineProperties(input, {
			valueLow: {
				get: function () {
					document.querySelector('[name=calories_min]').value = Math.min(this.originalValue, ghost.value);	
					return Math.min(this.originalValue, ghost.value);
				},
				set: function (v) {
					this.originalValue = v;
				},
				enumerable: true
			},
			valueHigh: {
				get: function () {
					document.querySelector('[name=calories_max]').value = Math.max(this.originalValue, ghost.value);				
					return Math.max(this.originalValue, ghost.value);
				},
				set: function (v) {
					ghost.value = v;
				},
				enumerable: true
			}
		});

		if (descriptor.get) {
			Object.defineProperty(input, "value", {
				get: function () {
					return this.valueLow + "," + this.valueHigh;
				},
				set: function (v) {
					var values = v.split(",");
					this.valueLow = values[0];
					this.valueHigh = values[1];
					update();
				},
				enumerable: true
			});
		}

		if (typeof input.oninput === "function") {
			ghost.oninput = input.oninput.bind(input);
		}

		function update() {
			ghost.style.setProperty("--low", 100 * ((input.valueLow - input.min) / (input.max - input.min)) + 1 + "%");
			ghost.style.setProperty("--high", 100 * ((input.valueHigh - input.min) / (input.max - input.min)) - 1 + "%");
		}

		input.addEventListener("input", update);
		ghost.addEventListener("input", update);

		update();
		
		function change() {
			let rangeChangedEvent = new CustomEvent('rangeChanged');
			document.dispatchEvent(rangeChangedEvent);
		}
		
		input.addEventListener("change", change);
		ghost.addEventListener("change", change);		
	}

	multirange.init = function () {
		[].slice.call(document.querySelectorAll("input[type=range][multiple]:not(.multirange)")).forEach(multirange);
	}

	if (typeof module === "undefined") {
		self.multirange = multirange;
		if (document.readyState == "loading") {
			document.addEventListener("DOMContentLoaded", multirange.init);
		} else {
			multirange.init();
		}
	} else {
		module.exports = multirange;
	}
};

// rangeSlider();

if (typeof eventsListing !== 'undefined' && eventsListing) {
	(eventsRicercaListing = () => {
		//SU CARD
		const cards = document.querySelectorAll(".gz-card-search a");
		for(const el of cards){
			el.addEventListener('click', event => {
				let index = el.closest('article.gz-card').dataset.index;
				if(index) {
					let url = el.getAttribute("href");
					let label = `${index}, ${url}`;

					if(el.dataset.recipeurl){
						let recipeurl = el.dataset.recipeurl;	
						label += `, ${recipeurl}`;
					}
						
					eventAnalytics('Click su risultato', 'Search', label);
				}
			});
		}

		for(const el of document.querySelectorAll('.gz-row-filters a')){
			el.addEventListener('click', event => {
				let action = el.dataset.varsAction;
				eventAnalytics(action, 'Search', window.location.href);
			});
		}
	})();
}

if (typeof events !== 'undefined' && events) {
	(eventsRicercaRicette = () => {
		var splitPathname = window.location.pathname.split( '/' );
		var labelEventQueryString = splitPathname[2].replace(/\+/g, ' ');
	
		//SE IL REFERRER E' GIALLOZAFFERANO
		if (document.referrer.indexOf('giallozafferano.it') >= 0 || document.referrer.indexOf('giallozafferano.com') >= 0) {
			eventAnalytics('NaturalSearch', 'Search', labelEventQueryString, true);
		}

		if (suggest && query) {
			eventAnalytics('view: '+query, 'didyoumean', 'spellcheck: '+suggest, true);
	
			document.querySelector('.didyoumean').addEventListener('click', function() {
				eventAnalytics('click: '+query, 'didyoumean', 'spellcheck: '+suggest);
			});
	
		}

		//SU SPECIALI
		const boxSpecials = document.querySelectorAll("#gz-block-specials article a");
	
		//evento view
		var listSpecials = '';
	
		for (let i = 0; i < boxSpecials.length; i++) {
			listSpecials += boxSpecials[i].getAttribute('title');
			if (i != (boxSpecials.length - 1)) listSpecials += ';';
		}
	
		if (listSpecials != '') {
			/*
			eventAnalytics('view: '+query, 'speciali', listSpecials, true);
			*/
		}
	
		//evento click
		for (let i = 0; i < boxSpecials.length; i++) {
			boxSpecials[i].addEventListener("click", function() {
				eventAnalytics('view: '+query, 'speciali', boxSpecials[i].getAttribute('title'), true);
			});
		}
	})();
}

if(document.querySelector('.gz-switch-view')){
	for(const el of document.querySelectorAll('.gz-switch-view a:not(.active)')){
		el.addEventListener('click', event => {
			event.preventDefault();
			var className = el.dataset.class;
		
			//rimuovo da tutti la classe active e la aggiungo solo al this
			document.querySelectorAll('.gz-switch-view a').forEach(elem => {
				elem.classList.remove('active');
			});
			el.classList.add('active');
		
			var	colorVerticalIcon = (document.querySelector('.gz-switch-view a[data-class=gz-vertical-view]').classList.contains('active')) ? '-orange' : '',
				colorHorizontalIcon = (document.querySelector('.gz-switch-view a[data-class=gz-horizontal-view]').classList.contains('active')) ? '-orange' : '';
		
			//aggiungo la classe alle card per la vista selezionata (className)
			document.querySelectorAll('.gz-card.gz-card-horizontal:not(.gz-card-special)').forEach(elem => {
				elem.classList.remove('gz-horizontal-view');
				elem.classList.remove('gz-vertical-view');
			});
			document.querySelectorAll('.gz-card.gz-card-horizontal:not(.gz-card-special)').forEach(elem => {
				elem.classList.add(className);
			});
			document.querySelector('.gz-switch-view a[data-class=gz-horizontal-view]').querySelector(":scope svg").innerHTML = '<use xlink:href="/style/images/icons.svg#view-card-horizontal'+colorHorizontalIcon+'"></use>';
			document.querySelector('.gz-switch-view a[data-class=gz-vertical-view]').querySelector(":scope svg").innerHTML = '<use xlink:href="/style/images/icons.svg#view-card-vertical'+colorVerticalIcon+'"></use>';
		});
	}
}

var serialize = (form) => {
	var arr = [];
	Array.prototype.slice.call(form.elements).forEach((field) => {
		if (!field.name || field.disabled || ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1) return;
		if (field.type === 'select-multiple') {
			Array.prototype.slice.call(field.options).forEach((option) => {
				if (!option.selected) return;
				arr.push(field.name + '=' + option.value);
			});
			return;
		}
		if (['checkbox', 'radio'].indexOf(field.type) >-1 && !field.checked) return;
		arr.push(field.name + '=' + field.value);
	});
	return arr.join('&');
}